<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" title="101 Things to do With Chicken">
<div class="recto">
<h1><a id="id1527026">101 Things to do With Chicken</a></h1><a id="id1527026">
<h3>Donna Kelly and Stephanie Ashcraft</h3>
<img alt="Gibbs Smith Logo" src="Resources/logo.png"/>
</a></div><a id="id1527026">
</a></div><a id="id1527026">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// recto.vue?2ba950f6